Vue.component('AclRouteIndexComponent', require('./components/AclRouteIndexComponent').default);
Vue.component('AclRouteGetComponent', require('./components/AclRouteFormComponent').default);
Vue.component('AclEntityFieldIndexComponent', require('./components/AclEntityFieldIndexComponent').default);
Vue.component('AclEntityFieldGetComponent', require('./components/AclEntityFieldFormComponent').default);

function is_allowed_field(resource, access) {
    if (!resource) {
        return true;
    }
    let rules = AclPermissions.forbiddenFields[access];

    if (_.isEmpty(rules)) {
        return true;
    }

    if (rules[0] === '*') {
        return false;
    }

    let object = resource.split('.')[0];
    let field = resource.split('.')[1];

    if (_.isUndefined(rules[object])) {
        return true;
    }

    if (rules[object] === '*') {
        return false;
    }

    if (rules[object].indexOf(field) !== -1) {
        return false;
    }

    let fieldWithoutId = field.replace(/_id$/, '');

    return rules[object].indexOf(fieldWithoutId) === -1;
}

function is_allowed(route) {
    return _.includes(AclPermissions.routes, route);
}

function user_can(ability) {
    return _.includes(AclPermissions.abilities, ability);
}

window.can = function (ability) {
    return is_allowed(ability) || user_can(ability);
};

window.is_readable = function (resource) {
    return is_allowed_field(resource, 'read');
};

window.is_writeable = function (resource) {
    return is_allowed_field(resource, 'write');
};
